import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-2xl text-background-50">韩漫大全</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed mb-8 max-w-sm">
              韩漫网站打造无删减韩国漫画下拉式免费韩漫大全平台，资源丰富多元，无广告干扰，让您享受纯净阅读时光。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-300 hover:text-primary-400 hover:border-primary-400 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-300 hover:text-primary-400 hover:border-primary-400 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-300 hover:text-primary-400 hover:border-primary-400 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-300 hover:text-primary-400 hover:border-primary-400 transition-colors duration-200" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-background-50 text-sm font-semibold mb-5 whitespace-nowrap">快速导航</h4>
            <nav className="flex flex-col gap-3" aria-label="页脚导航">
              <Link to="/" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
              <Link to="/category/fantasy" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">热门推荐</Link>
              <a href="#" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">最新更新</a>
            </nav>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-background-50 text-sm font-semibold mb-5 whitespace-nowrap">热门分类</h4>
            <nav className="flex flex-col gap-3" aria-label="分类导航">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  <i className={`${cat.icon} mr-2`}></i>{cat.name}
                </Link>
              ))}
            </nav>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-background-50 text-sm font-semibold mb-5 whitespace-nowrap">联系我们</h4>
            <div className="flex flex-col gap-3">
              <p className="text-foreground-400 text-sm whitespace-nowrap">
                <i className="ri-mail-line mr-2"></i>hello@jorjigsrp.com
              </p>
              <p className="text-foreground-400 text-sm whitespace-nowrap">
                <i className="ri-customer-service-2-line mr-2"></i>在线客服：工作日 9:00-18:00
              </p>
              <p className="text-foreground-400 text-sm whitespace-nowrap">
                <i className="ri-map-pin-line mr-2"></i>中国 · 北京
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/50">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs whitespace-nowrap">
            &copy; 2026 韩漫大全 HanMan123.com 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">服务条款</a>
            <a href="#" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}